const { Component } = require('react')
const PropTypes = require('prop-types')
const Image = require('app/components/mixins/Image')
const router = require('app/services/router')
const LazyImg = require('app/components/mixins/LazyImg')
const Highlight = require('app/components/products/Highlight')
const { numberFormat } = require('app/util/formaters')
const SegmentTracking = require('app/services/segmentTracking')
const Trans = require('app/components/trans/Trans')

class SingleProduct extends Component {
  static get propTypes () {
    return {
      name: PropTypes.string.isRequired,
      available: PropTypes.bool.isRequired,
      price: PropTypes.object.isRequired,
      priceFrom: PropTypes.number.isRequired,
      picture: PropTypes.object.isRequired,
      genderTarget: PropTypes.string,
      genderTargetName: PropTypes.string,
      url: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      url: '#'
    }
  }

  get className () {
    return [
      'product',
      this.props.available ? null : 'unavailable'
    ].filter(e => e).join(' ')
  }

  get price () {
    return numberFormat(this.props.priceFrom)
  }

  get priceHtml () {
    let priceFrom = null

    if ((this.props.price.values.length > 1) || (this.props.price.custom)) {
      priceFrom = (<span className='from'><Trans>Fra</Trans></span>)
    }

    return (
      <div className='price'>
        {priceFrom}
        {this.price}
      </div>
    )
  }

  get variationsHtml () {
    if (this.props.price.values.length > 1) {
      return (<div className='variations'>{this.props.price.values.length} <Trans>varianter</Trans></div>)
    }
  }

  get variationsMobileHtml () {
    if (this.props.price.values.length > 1) {
      return (<div className='variations variations-mobile'>{this.props.price.values.length} <Trans>varianter</Trans></div>)
    } else {
      return (<div className='variations variations-mobile'><Trans>1 variant</Trans></div>)
    }
  }

  get genderIconHtml () {
    if (['men', 'women'].indexOf(this.props.genderTarget) !== -1) {
      return (
        <div className='gender-icon'>
          <span>{this.props.genderTargetName}</span>
          <div><Image src={router.url(`img/icons/${this.props.genderTarget}.png`)} alt='Gender' /></div>
        </div>
      )
    }
  }

  get genderInfoHtml () {
    if (['men', 'women'].indexOf(this.props.genderTarget) !== -1) {
      return (
        <div className='gender-info'>
          <Image src={router.url(`img/icons/${this.props.genderTarget}.png`)} alt='Gender' />
          <span>{this.props.genderTargetName}</span>
        </div>
      )
    }
  }

  render () {
    return (
      <div className={this.className} data-gender={this.props.genderTarget}>
        <div className='product-top'>
          <div className='object-fit picture'>
            <a href={this.props.url} {...SegmentTracking.getProductClickedEvents(this.props.id)}>
              <Highlight {...this.props.highlight} />
              <LazyImg src={router.url('img/lazy_placeholder.png')} distance={20} src={this.props.picture.b} name={this.props.name} />
            </a>
          </div>
          {this.genderIconHtml}
          <div className='details'>
            {this.variationsMobileHtml}
            <div className='name'>
              <a href={this.props.url} {...SegmentTracking.getProductClickedEvents(this.props.id)}>{this.props.name}</a>
            </div>
            <div className='info'>
              {this.priceHtml}
              {this.variationsHtml}
            </div>
          </div>
        </div>
        <div className='product-bottom'>
          <div className='bar'>
            {this.genderInfoHtml}
            <a className='bar-link' href={this.props.url} {...SegmentTracking.getProductClickedEvents(this.props.id)}><Trans>Se mere</Trans></a>
          </div>
        </div>
      </div>
    )
  }
}

module.exports = SingleProduct
